import api from '../services/api'
import { utilsDownloadFromResponse, utilsShowErrorInDevelopmentEnvironment } from '../utils'

export function resolveActionEndpoint(endpoint) {
  if (/^https?:\/\//i.test(endpoint)) {
    return endpoint
  }
  const baseURL = (api.defaults && api.defaults.baseURL) || process.env.VUE_APP_ROOT_API || ''
  const baseVersion = baseURL.replace(/\/+$/, '').split('/').pop()
  const path = endpoint.replace(/^\/+/, '')
  if (baseVersion && /^v\d+$/i.test(baseVersion) && path.toLowerCase().startsWith(`${baseVersion.toLowerCase()}/`)) {
    return path.slice(baseVersion.length + 1)
  }
  return path
}

export default {
  methods: {
    onAction({ action, columns, rows, row, files, onSettled } = {}) {
      if (files) {
        return this.dispatchUpload(action, files).then((result) => onSettled && onSettled(result))
      }
      const input = row !== undefined ? { row } : { columns, rows }
      this.dispatchAction(action, input)
    },
    async dispatchAction(action, input) {
      if (!action || !action.endpoint || !action.method) {
        return
      }
      const body = {
        ...(action.body || {}),
        ...(action.send_own_data && input ? { input } : {})
      }
      try {
        const response = await api({
          method: action.method,
          url: resolveActionEndpoint(action.endpoint),
          data: body,
          responseType: 'blob'
        })
        this.handleActionResponse(response)
      } catch (error) {
        const message = error.response && error.response.data && error.response.data.messages
          ? error.response.data.messages[0]
          : 'Erro ao executar a ação.'
        this.showFeedback({ color: 'error', message })
      }
    },
    async dispatchUpload(action, files) {
      if (!action || !action.endpoint || !action.method || !files || !files.length) {
        return { failedFiles: files || [] }
      }
      const failedFiles = []
      let lastError = null
      for (const file of files) {
        const formData = new FormData()
        formData.append('file', file)
        try {
          await api({
            method: action.method,
            url: resolveActionEndpoint(action.endpoint),
            data: formData,
            headers: { 'Content-Type': 'multipart/form-data' }
          })
        } catch (error) {
          utilsShowErrorInDevelopmentEnvironment(error)
          failedFiles.push(file)
          lastError = error
        }
      }
      this.showFeedback(this.uploadFeedback(action, files, failedFiles, lastError))
      return { failedFiles }
    },
    uploadFeedback(action, files, failedFiles, lastError) {
      if (!failedFiles.length) {
        return { color: 'info', message: action.successMessage || 'Arquivo enviado para processamento.' }
      }
      const apiMessage = lastError && lastError.response && lastError.response.data && lastError.response.data.messages
        ? lastError.response.data.messages[0]
        : ''
      if (files.length === 1) {
        return { color: 'error', message: apiMessage || 'Erro ao enviar o arquivo.' }
      }
      const names = failedFiles.map((file) => file.name).join(', ')
      return { color: 'error', message: `Não foi possível enviar: ${names}.${apiMessage ? ` ${apiMessage}` : ''}` }
    },
    handleActionResponse(response) {
      const contentType = ((response.headers && response.headers['content-type']) || '').toLowerCase()
      if (contentType.includes('application/json')) {
        return
      }
      utilsDownloadFromResponse(response)
    }
  }
}
